"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentPropertiesKeywords = void 0;
var map_creator_1 = require("../../../base-utils/map-creator");
var info_destination_1 = require("../destination/info/info-destination");
exports.documentPropertiesKeywords = new map_creator_1.MapCreator()
    .add("category", info_destination_1.InfoDestination.onCategoryKeyword)
    .add("creatim", info_destination_1.InfoDestination.onCreatedKeyword)
    .add("doccomm", info_destination_1.InfoDestination.onDescriptionKeyword)
    .add("author", info_destination_1.InfoDestination.onCreatorKeyword)
    .add("keywords", info_destination_1.InfoDestination.onKeywordsKeyword)
    .add("operator", info_destination_1.InfoDestination.onLastModifiedByKeyword)
    .add("printim", info_destination_1.InfoDestination.onLastPrintedKeyword)
    .add("revtim", info_destination_1.InfoDestination.onModifiedKeyword)
    .add("version", info_destination_1.InfoDestination.onRevisionKeyword)
    .add("subject", info_destination_1.InfoDestination.onSubjectKeyword)
    .add("title", info_destination_1.InfoDestination.onTitleKeyword)
    .get();
